exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../../../postcss-loader/index.js!../../styles/colors.cssm"), undefined);
exports.i(require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../../../postcss-loader/index.js!../../styles/typography.cssm"), undefined);

// module
exports.push([module.id, "._1-u8yQsAFJjMfZDx7pjMNJ{font-size:10px;color:" + require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../../../postcss-loader/index.js!../../styles/colors.cssm").locals["text-regular"] + ";margin:0}", ""]);

// exports
exports.locals = {
	"text-regular": "" + require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../../../postcss-loader/index.js!../../styles/colors.cssm").locals["text-regular"] + "",
	"base": "_1-u8yQsAFJjMfZDx7pjMNJ " + require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../../../postcss-loader/index.js!../../styles/typography.cssm").locals["mono"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/~/css-loader?modules&importLoaders=1!./~/postcss-loader!./~/@chartbeat/light-side/lib/components/json-view/json-view.cssm
// module id = 157
// module chunks = 0